import { API_ENPOINTS } from '../../constants/api';
import { get, put, post, uploadFile } from '../../utils/requests';
import { deserializeTest, serializeTest, removeUnnecessaryValues } from './serializers';

const Dinamic_API = API_ENPOINTS.DinamicTest;

export const fetchDynamicTestDataById = (id) => {
  const endpoint = `${Dinamic_API}/${id}`;
  return get(endpoint).then(deserializeTest);
};

export const updateDinamicTest = (layoutId, testId, values, forceOverwrite = false) => {
  const endpoint = `${Dinamic_API}/${testId}`;

  return put(endpoint, {
    forceOverwrite,
    layoutId,
    values: removeUnnecessaryValues(values),
  });
};



// WEBPACK FOOTER //
// src/actions/dinamicTest/apiRequests.js